import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import { formatDateTime, reverseFormatDate } from '../../../../utils/dateFunctions';

import classes from '../../../../commonStyles/tables.module.css';

const HmrcDataTableRow = ({ row }) => {
    return (
        <TableRow hover className={`${classes.basicRowStripes}`}>
            <TableCell>{row.notificationType || '-'}</TableCell>
            <TableCell>
                {row.notificationDate ? reverseFormatDate(row.notificationDate) : ' - '}
            </TableCell>
            <TableCell>{row.eventDate ? reverseFormatDate(row.eventDate) : ' - '}</TableCell>
            <TableCell>{row.dateUploaded ? formatDateTime(row.dateUploaded) : ' - '}</TableCell>
        </TableRow>
    );
};

HmrcDataTableRow.propTypes = {
    row: PropTypes.object
};

export default HmrcDataTableRow;
